import { connect } from 'react-redux';
import AdRules from '../../components/sections/pluginSettings/AdRules';
import { addNewAdRule, setSsar } from '../../actions';

const mapStateToProps = state => {
  return {
    adRules: state.adRules.data,
    ssar: state.configuration.publisher.enableSSAR,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addNewAdRuleAction: () => {
      dispatch(addNewAdRule());
    },
    setSsar: active => {
      dispatch(setSsar(active));
    },
  };
};

const AdRulesRedux = connect(mapStateToProps, mapDispatchToProps)(AdRules);

export default AdRulesRedux;
